export enum AuthType {
  Base = 1,
  JWT = 2
}
